import { LuEye, LuSave } from "react-icons/lu";

const formatSavedAt = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat("fa-IR", { hour: "2-digit", minute: "2-digit" }).format(date);
};

const SaveMenuButton = ({ onSave, onPreview, saving, isDirty, lastSavedAt }) => {
  const savedTime = formatSavedAt(lastSavedAt);
  return (
    <div className="sticky bottom-0 z-20 border-t border-gray-100 bg-white/95 px-4 py-3 backdrop-blur">
      <div className="mx-auto flex max-w-6xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-gray-500" aria-live="polite">{saving ? "در حال ذخیره تغییرات…" : isDirty ? "تغییرات ذخیره‌نشده دارید." : savedTime ? `آخرین ذخیره: ${savedTime}` : "همه تغییرات ذخیره شده‌اند."}</p>
        <div className="flex gap-2">
          <button type="button" onClick={onPreview} className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-xl border border-gray-200 px-4 text-sm font-bold text-gray-700 hover:bg-gray-50 sm:flex-none"><LuEye /> پیش‌نمایش</button>
          <button type="button" onClick={onSave} disabled={saving || !isDirty} className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-xl bg-primary px-5 text-sm font-bold text-white transition-colors hover:bg-[#e8731f] disabled:cursor-not-allowed disabled:opacity-50 sm:flex-none"><LuSave /> {saving ? "در حال ذخیره…" : "ذخیره منو"}</button>
        </div>
      </div>
    </div>
  );
};

export default SaveMenuButton;
